import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Div from '../Div';

export default function FullScreenHorizontalSlider({ data }) {
  const swiperRef = useRef(null);

  return (
    <Div className="cs-swiper_arrow_style_1">
      <Swiper
        ref={swiperRef}
        slidesPerView={1}
        spaceBetween={0}
        pagination={{ clickable: true }}
        speed={1000}
        loop={true}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        modules={[Pagination, Autoplay]}
        className="mySwiper"
        style={{
          height: '100vh', // Ensure this isn't blocking scroll
          position: 'relative', // Make sure it doesn't use fixed positioning
          zIndex: 1 // Lower z-index to ensure it doesn't block scrolling
        }}
      >
        {data.map((item, index) => (
          <SwiperSlide key={index}>
            <Div
              className="cs-hero cs-style4 cs-bg"
              style={{
                backgroundImage: `url(${item.imgUrl})`,
                height: '100%', // Use relative height
                pointerEvents: 'auto' // Ensure click events work
              }}
            >
              <Link to={item.href} className="cs-hero_link" />
              <Div className="cs-hero_text">
                <h2 className="cs-hero_title">{parse(item.title || '')}</h2>
              </Div>
            </Div>
          </SwiperSlide>
        ))}
      </Swiper>
    </Div>
  );
}